<div class="wrapper">
    <div class="content">
        <h1>Thank you for registering</h1>
        <h2>Your registration request has been received and will be approved by our sales team as soon as possible, you'll be redirected to the dashboard as soon as it's approved or come back later when you receive the approval email.</h2>
    </div>
</div>
